export const GrantInitialState = {
    grant_id: '',
};
export const GrantProviderInitialState = {
    grant_provider_id: '',
};
export const EssorVolet1BId = '6623e97b-5980-4898-9afb-bc69b29de180';
export const LoanFinancingTypeId = 'd3fbae6d-f728-43f0-a660-efceb3f150e4';
export var PromptType;
(function (PromptType) {
    PromptType["Grant"] = "grant";
    PromptType["Program"] = "program";
})(PromptType || (PromptType = {}));
export var GrantTargetType;
(function (GrantTargetType) {
    GrantTargetType["Individual"] = "individual";
    GrantTargetType["Organization"] = "organization";
})(GrantTargetType || (GrantTargetType = {}));
export const GrantMaturityTypes = [
    'startup',
    'growth',
    'mature',
];
